import type { HskVersionKey } from "@-/dev.improve.haniverse.lib.morpheme.grade.hsk";

export const HSK_VERSION_LABEL: Record<HskVersionKey, string> = {
  hsk2: "HSK 2.0",
  hsk2026: "New HSK",
  hsk3: "HSK 3.0",
};

export const DAILY_REVIEW_WINDOW_DAYS = 14;

export const RETENTION_WEEKS = 6;

export const FSRS_STATE_PALETTE: readonly { color: string; label: string }[] = [
  { color: "#D97706", label: "New" },
  { color: "#0F766E", label: "Learning" },
  { color: "#2563EB", label: "Review" },
  { color: "#DB2777", label: "Relearning" },
];

export const HSK_BAR_COLORS = [
  "#16A34A",
  "#0891B2",
  "#2563EB",
  "#7C3AED",
  "#DB2777",
  "#D97706",
  "#475569",
] as const;

export const COVERAGE_TIMELINE_POINTS = 12;
